var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M507.5,175.2c-3.6-4.3-9-6.8-14.6-6.8h-53L335.7,26.6c-6.2-8.5-18.2-10.3-26.7-4.1 c-8.5,6.2-10.3,18.2-4.1,26.7l87.5,119.2h-278L202,49.2c6.2-8.5,4.4-20.5-4.1-26.7c-8.5-6.2-20.5-4.4-26.7,4.1L67,168.4H19.1 c-5.6,0-10.9,2.5-14.6,6.8s-5.2,9.9-4.3,15.5L48,477.3c1.5,9.2,9.5,16,18.8,16h378.3c9.3,0,17.3-6.8,18.8-16l47.8-286.6 C512.7,185.1,511.1,179.5,507.5,175.2z M429,455H83L41.7,206.6h428.7L429,455z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M256,251.2c-10.6,0-19.1,8.6-19.1,19.1v125.5c0,10.6,8.6,19.1,19.1,19.1s19.1-8.5,19.1-19.1V270.3 C275.1,259.8,266.6,251.2,256,251.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M354.7,251.2c-10.6,0-19.1,8.6-19.1,19.1v125.5c0,10.6,8.6,19.1,19.1,19.1c10.6,0,19.1-8.5,19.1-19.1 V270.3C373.8,259.8,365.3,251.2,354.7,251.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M157.3,251.2c-10.6,0-19.1,8.6-19.1,19.1v125.5c0,10.6,8.6,19.1,19.1,19.1s19.1-8.5,19.1-19.1V270.3 C176.4,259.8,167.8,251.2,157.3,251.2z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasket);
export default __webpack_public_path__ + "static/media/shopping-basket.a4656393076c7fe649ea598486b7b5a1.svg";
export { ForwardRef as ReactComponent };